import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    text: "El Dr. es amable y accesible, algo que se aprecia mucho cuando trata a un adulto mayor. Sus tratamientos son muy acertados.",
    author: "Alma",
    role: "Paciente · Adulto mayor",
    highlight: "Trato humano",
  },
  {
    text: "Explicación perfecta, como en la vieja escuela: con dibujos y lenguaje fácil de entender.",
    author: "FSB",
    role: "Paciente",
    highlight: "Claridad médica",
  },
  {
    text: "Amplio conocimiento. Su explicación me dio demasiada confianza sobre el tratamiento.",
    author: "Rocío G.",
    role: "Paciente",
    highlight: "Confianza técnica",
  },
];

export const Testimonios = () => {
  return (
    <section id="testimonios" data-testid="testimonios-section" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <span className="text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--soft-red))] font-medium">
            · Voces de pacientes reales ·
          </span>
          <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[hsl(var(--navy))] leading-[1.1]">
            Lo que dicen quienes
            <br />
            ya <span className="italic font-light">confiaron</span>.
          </h2>
          <div className="mt-6 inline-flex items-center gap-2">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-[hsl(var(--gold))] text-[hsl(var(--gold))]" />
            ))}
            <span className="ml-2 text-sm text-[hsl(var(--navy-soft))]">5.0 · +31 reseñas verificadas</span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <figure
              key={i}
              data-testid={`testimonio-${i}`}
              className="relative rounded-2xl bg-[hsl(var(--cream))] border border-[hsl(var(--border))] p-7 flex flex-col transition-all hover:shadow-soft hover:-translate-y-1 duration-300"
            >
              <Quote className="w-8 h-8 text-[hsl(var(--soft-red))]/25 mb-3" fill="currentColor" />
              <blockquote className="font-serif-display text-lg md:text-xl text-[hsl(var(--navy))] leading-snug flex-1">
                "{r.text}"
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-[hsl(var(--border))] flex items-center justify-between">
                <div>
                  <div className="font-medium text-[hsl(var(--navy))]">{r.author}</div>
                  <div className="text-xs text-[hsl(var(--navy-soft))] uppercase tracking-wider mt-0.5">
                    {r.role}
                  </div>
                </div>
                <span className="text-[10px] uppercase tracking-[0.18em] text-[hsl(var(--soft-red))] bg-[hsl(var(--soft-red))]/10 px-2 py-1 rounded-full">
                  {r.highlight}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
